import { useMutation } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';
import { Cookies } from 'react-cookie';
import { TOtp } from '../../typescript/types/otp.type';
import { IBaseResponse } from '../../typescript/interfaces/common.interface';
import { attachApiErrorToastInterceptor } from '../../utils/api-error-toast';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_CART_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});
attachApiErrorToastInterceptor(axiosInstance);

axiosInstance.interceptors.request.use((config) => {
  const cookies = new Cookies();
  const token = cookies.get('session_token');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

axiosInstance.interceptors.response.use((response: AxiosResponse<IBaseResponse>) => response);

type useGetOTP = {
  otp: number | null;
  token: string | null;
};

export const verifyOTP = async (data: useGetOTP) => {
  try {
    return await axiosInstance.post<TOtp['orders-list-response'] & IBaseResponse>(`checkout/verify`, {
      otp: data.otp,
      token: data.token,
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const mutationOTP = () => {
  const mutation = useMutation({
    mutationFn: (formData: useGetOTP) => {
      return axiosInstance.post(`checkout/verify`, formData);
    },
  });
};
